// Estado vacío escrito por una persona, no por un programador. Nunca una
// tabla en blanco ni "No data": siempre un texto que dice qué pasa y, si
// aplica, qué hacer.
export default function EstadoVacio({ icono: Icono, titulo, descripcion, accion }) {
  return (
    <div className="flex flex-col items-center text-center py-14 gap-3 text-gray-500">
      {Icono && (
        <div className="bg-gray-100 rounded-2xl p-4">
          <Icono className="h-8 w-8 text-gray-500" />
        </div>
      )}
      <div className="font-semibold text-gray-700">{titulo}</div>
      {descripcion && <p className="text-sm max-w-sm leading-relaxed">{descripcion}</p>}
      {accion}
    </div>
  );
}
